import React from "react"
import { useIntl } from "gatsby-plugin-react-intl"
import PYSsvg from '../../assets/images/planYourStay.svg' //PYS = plan your stay
const PlanYourStay = ({ hotelId, locale }) => {
  const intl = useIntl()

  return locale === "en" ? (
    <a className="link planYourStay icon-Soleil" href="/en/plan-stay-mauritius"><span>Plan your stay</span></a>
  ) : (
    <a className="link planYourStay icon-Soleil " href="/planifier-sejour-ile-maurice"><span>Planifier votre séjour</span></a>
  )
}

export default PlanYourStay
